import { useDispatch, useSelector } from 'react-redux'
import { openBuyBonus } from '@slices/uiSlice'

// Betting panel header button — opens the purchase overlay. Kept out of
// BettingPanel.jsx (which stays focused on tab switching) so the component
// only ever renders, never dispatches directly.
export const useBuyBonusTrigger = () => {
  const dispatch = useDispatch()
  const isEnabled = useSelector((state) => state.configurations.featureToggles.buyBonus)

  const onOpen = () => dispatch(openBuyBonus())

  return { isEnabled, onOpen }
}
